/* =========================================================================
   Le Décor — variant picker
   Keeps price, compare-at price, discount badge, image and the hidden
   variant input in sync with the selected options.
   ========================================================================= */
(function () {
  'use strict';

  var dataEl = document.querySelector('[data-variant-data]');
  var picker = document.querySelector('[data-variant-picker]');
  if (!dataEl) return;

  var variants;
  try {
    variants = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  if (!variants || !variants.length) return;

  var strings = (window.LeDecor && window.LeDecor.strings) || {};
  var variantInput = document.querySelector('[data-variant-input]');
  var priceEl = document.querySelector('[data-price]');
  var compareEl = document.querySelector('[data-compare]');
  var discountEl = document.querySelector('[data-discount]');
  var addButton = document.querySelector('[data-add-button]');
  var buyButton = document.querySelector('[data-buy-now]');
  var addButtonText = document.querySelector('[data-add-button-text]');
  var mainImage = document.getElementById('detail-main-image');

  function selectedOptions() {
    if (!picker) return variants[0].options;
    var values = [];
    picker.querySelectorAll('[data-option-index]').forEach(function (el) {
      var index = Number(el.dataset.optionIndex);
      if (el.tagName === 'SELECT') {
        values[index] = el.value;
      } else if (el.checked) {
        values[index] = el.value;
      }
    });
    return values;
  }

  function findVariant(options) {
    return variants.find(function (variant) {
      return variant.options.every(function (value, index) {
        return value === options[index];
      });
    });
  }

  function updateAvailability(options) {
    if (!picker) return;
    picker.querySelectorAll('input[data-option-index]').forEach(function (input) {
      var index = Number(input.dataset.optionIndex);
      var candidate = options.slice();
      candidate[index] = input.value;
      var match = variants.find(function (variant) {
        return variant.options.every(function (value, i) {
          // only compare options up to and including this one
          return i > index ? true : value === candidate[i];
        });
      });
      input.disabled = !match || !match.available;
    });
  }

  function updateUrl(variant) {
    if (!variant || !window.history.replaceState) return;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  function update() {
    var options = selectedOptions();
    var variant = findVariant(options);

    updateAvailability(options);

    if (!variant) {
      if (addButton) addButton.disabled = true;
      if (buyButton) buyButton.disabled = true;
      if (addButtonText) addButtonText.textContent = strings.unavailable || 'Unavailable';
      return;
    }

    if (variantInput) variantInput.value = variant.id;

    if (priceEl) priceEl.innerHTML = variant.price_formatted;

    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.innerHTML = variant.compare_formatted;
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    if (discountEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        var pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
        discountEl.textContent = pct + '% OFF';
        discountEl.hidden = false;
      } else {
        discountEl.hidden = true;
      }
    }

    if (variant.media_src && mainImage) {
      mainImage.src = variant.media_src;
      document.querySelectorAll('.product-detail-thumb').forEach(function (thumb) {
        thumb.classList.toggle('active', Number(thumb.dataset.mediaId) === variant.media_id);
      });
    }

    if (addButton) addButton.disabled = !variant.available;
    if (buyButton) buyButton.disabled = !variant.available;
    if (addButtonText) {
      addButtonText.textContent = variant.available
        ? (strings.addToCart || 'Add to Cart')
        : (strings.soldOut || 'Sold Out');
    }

    updateUrl(variant);
  }

  if (picker) {
    picker.addEventListener('change', update);
    update();
  }
})();
